<template>
    <form class="form-horizontal group-border-dashed" @submit.prevent="handleSubmit" novalidate>
        <div class="form-group">
            <h3 class="wizard-title text-uppercase">Coach wählen</h3>
        </div>

        <be-card
            flat divider
            title="Bitte wählen Sie einen der folgenden zertifizierten Digital.Fitness Coaches aus."
            subtitle="Nach Abschluss dieses Checks wird sich der Coach bei Ihnen melden um ein kostenloses Assessment (nach Wahl telefonisch oder vor Ort) durchzuführen."
        >
            <div class="row">
                <df-await v-if="!coaches"/>
                <template v-else>
                    <df-coach class="col-4" :data="coach" v-for="coach in coaches" :key="coach.id">
                        <radio-checkbox
                            name="coach"
                            :options="[{ value: coach.resourceId, label: 'diesen Coach wählen' }]"
                            :disabled="disabled"
                            v-model="formData.coachId"
                        />
                    </df-coach>
                </template>
            </div>
        </be-card>

        <validation :validation="$v.formData.coachId"/>

        <div class="form-group" v-if="!disabled">
            <button class="btn btn-lg btn-secondary btn-space" type="button" @click.prevent="$emit('previous', formData)">zurück</button>
            <button class="btn btn-lg btn-success btn-space wizard-next" type="submit">Digital.Check abschliessen – kostenloses Assessment buchen</button>
        </div>
    </form>
</template>

<script>
    import { withParams } from 'vuelidate';
    import { required } from 'vuelidate/lib/validators';

    import Coaches from '../../../data/Coaches';
    import exam from '../../../mixins/exam';

    export default {
        mixins: [exam],

        data: () => ({
            formData: {
                coachId: '',
            },
        }),

        asyncComputed: {
            coaches: () => Coaches.all(),
        },

        validations: {
            formData: {
                coachId: {
                    required: withParams({ message: 'Bitte wählen Sie einen Coach aus.' }, required),
                },
            },
        },
    };
</script>
